import { useMutation, gql } from '@apollo/client';
import {
  AutenticarMutation,
  AutenticarMutationVariables,
} from './__generated__/AutenticarMutation';

const AUTENTICAR_MUTATION = gql`
  mutation AutenticarMutation(
    $dsc_nome_usuario: String!
    $senha: String!
    $id_tipo_usuario: Int!
    $manter_conectado: Boolean!
  ) {
    autenticar(
      input: {
        dsc_nome_usuario: $dsc_nome_usuario
        senha: $senha
        id_tipo_usuario: $id_tipo_usuario
        manter_conectado: $manter_conectado
      }
    ) {
      token
      refresh_token
    }
  }
`;

const useAutenticarMutation = () => {
  return useMutation<AutenticarMutation, AutenticarMutationVariables>(AUTENTICAR_MUTATION);
};

export { useAutenticarMutation };
